import React from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { BADGE } from 'client/data/models/type-rankings-entities';
import { buildBadgesPath, TypeRankingsFeaturesModel } from 'client/data/models/type-rankings-features';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { Link } from 'site-modules/shared/components/link/link';

import './top-rated-ribbon.scss';

export function TopRatedRibbonUI({ vehicleParams, topRatedBadge }) {
  const BADGES = {
    [BADGE.TOP_RATED_BOB]: {
      src: '/img/top-rated/badges/2026/gold.svg',
      alt: `Edmunds ${vehicleParams.year} Top Rated: Best of the Best`,
    },
    [BADGE.TOP_RATED_GAS]: {
      src: '/img/top-rated/badges/2026/blue.svg',
      alt: `Edmunds ${vehicleParams.year} Top Rated: Best Gas`,
    },
    [BADGE.TOP_RATED_EV]: {
      src: '/img/top-rated/badges/2026/teal.svg',
      alt: `Edmunds ${vehicleParams.year} Top Rated: Best Electric`,
    },
  };
  const badge = BADGES[topRatedBadge];

  if (!badge) {
    return null;
  }

  return (
    <Link
      to="/top-rated/"
      data-tracking-id="top_rated_badge"
      style={{ position: 'absolute', top: '-8px', left: '16px' }}
    >
      <img src={getStaticImageUrl(badge.src)} alt={badge.alt} width={117} loading="lazy" />
    </Link>
  );
}

TopRatedRibbonUI.propTypes = {
  vehicleParams: PropTypes.shape({
    makeSlug: PropTypes.string,
    modelSlug: PropTypes.string,
    submodelSlug: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  topRatedBadge: PropTypes.oneOf(Object.values(BADGE)),
};

export const TopRatedRibbon = connectToModel(TopRatedRibbonUI, {
  topRatedBadge: bindToPath(
    ({ vehicleParams }) => buildBadgesPath(vehicleParams),
    TypeRankingsFeaturesModel,
    badges => badges.find(badge => Object.keys(BADGE).includes(badge))
  ),
});
